/** A slatted bench on iron legs (lantern-water `world.js` `createTown`, the `bench` pieces of `layout.js`). */
import * as THREE from 'three';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'bench',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { box, m } = ctx;
    box(root, 0, 0.52, 0, 1.65, 0.12, 0.5, m.wood);
    box(root, 0, 0.96, -0.24, 1.65, 0.55, 0.08, m.wood);
    for (const sign of [-1, 1]) box(root, sign * 0.65, 0.25, 0, 0.08, 0.5, 0.38, m.iron);
    return { root };
  },
};
